import { make } from 'vuex-pathify';
import { ContactService } from '@/services/contacts';
import { errorCatch } from '../utils';
import { Contact } from '@/models/contact';

const contactService = new ContactService();

export const state = {
  loading: false,
  contacts: [],
  contactInstance: {},
  lastRemovedContact: {},
  lastEditedContact: {},
  error: {}
};

export const mutations = {
  REMOVE_CONTACT(state: any, payload: any) {
    const index = state.contacts.indexOf(payload);
    state.contacts.splice(index, 1);
  },
  ADD_CONTACT(state: any, payload: any) {
    state.contacts.push(payload);
  },
  UPDATE_CONTACT(state: any, payload: any) {
    const lastEditedContact = state.contacts.find(
      (contact: { id: string }) => contact.id === payload
    );
    const objIndex = state.contacts.findIndex(
      (obj: any) => obj.id === payload.id
    );
    state.contacts[objIndex] = lastEditedContact;
  },
  ...make.mutations(state),
  SET_ERROR(state: any, error: any) {
    errorCatch(state, error);
  },
  CLEAR_ERROR(state: any) {
    state.error = {};
  }
};

export const actions = {
  clearError: ({ commit }: any) => commit('CLEAR_ERROR'),
  fetchContacts: async ({ commit, dispatch }: any) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      contactService
        .fetchContacts()
        .then(res => {
          commit('SET_CONTACTS', res);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          // error place holder commit('error/SET_ERROR', err, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },
  fetchContact: async ({ commit, dispatch }: any, payload: number) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      contactService
        .fetchContact(payload)
        .then((contact: Contact) => {
          const index = state.contacts.findIndex(
            (s: Contact) => s.id === payload
          );
          if (index === -1) {
            commit('ADD_CONTACT', contact);
          } else {
            commit('UPDATE_CONTACT', contact);
          }
          resolve(contact);
        })
        .catch(err => {
          commit('SET_ERROR', err);
          // error place holder commit('error/SET_ERROR', err, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },
  createContact: async ({ commit, dispatch }: any, payload: object) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      contactService
        .createContact(payload)
        .then(res => {
          commit('ADD_CONTACT', res);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          // error place holder commit('error/SET_ERROR', err, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },
  updateContact: async (
    { commit, dispatch }: any,
    payload: { data: Contact; id?: number }
  ) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      contactService
        .updateContact(payload.data, payload.id)
        .then(res => {
          commit('UPDATE_CONTACT', res);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          // error place holder commit('error/SET_ERROR', err, {root: true})
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },
  deleteContact: async ({ commit, dispatch }: any, payload: number) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      contactService
        .deleteContact(payload)
        .then(() => {
          commit('REMOVE_CONTACT', payload);
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  }
};

export const getters = {
  getLoading: (state: any) => state.loading,
  getlastRemovedContact: (state: any) => state.lastRemovedContact,
  getlastEditedContact: (state: any) => state.lastEditedContact,
  getContactList: (state: any) => state.contacts,
  getContactById: (state: any) => (id: number) => {
    return state.contacts.find((contact: Contact) => contact.id === id);
  }
};
